// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"22":"56ee8317","118":"ea69df7c","327":"63caef42","358":"426cb832","431":"3e0be22b","473":"d5ccf48b","518":"681e2ac4","761":"08d23fb2","765":"60fc13aa","779":"ec2f5f1a"}[chunkId] + ".js";
};